import React from 'react';
import { DOCUMENT_REQUEST_CATEGORY } from 'common/constants/process-management';
import CurrentRequestedDocumentTables from './CurrentRequestedDocumentTables';
import { CurrentRequestedDocumentsAndQuestionsProps, DocumentProgress } from './types';

const CurrentRequestedDocument = ({ currentInformationRequests }: CurrentRequestedDocumentsAndQuestionsProps) => {
  const documents = currentInformationRequests.find(request => request.category === DOCUMENT_REQUEST_CATEGORY);

  const filteredDocuments = {
    id: documents?.id,
    responsible_users:
      documents?.responsible_users?.map(user => ({
        full_name: user.full_name,
      })) || [],
    progress:
      documents?.progress?.filter(
        (item): item is DocumentProgress => 'files' in item && 'is_uploaded' in item && 'tags' in item
      ) || [],
  };

  return <CurrentRequestedDocumentTables documents={filteredDocuments} />;
};

export default CurrentRequestedDocument;
